// Restfest Theme JS

// Collection sort/filter
function applyCollectionSort(select) {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', select.value);
  // Re-sorting has to return to page 1 — otherwise sorting from page 3 lands
  // the shopper on page 3 of the newly sorted results.
  url.searchParams.delete('page');
  window.location.href = url.toString();
}

function applyCollectionFilter(select) {
  const url = new URL(window.location.href);
  if (select.value) {
    url.searchParams.set('filter.p.availability', select.value);
  } else {
    url.searchParams.delete('filter.p.availability');
  }
  url.searchParams.delete('page');
  window.location.href = url.toString();
}

// Restore filter/sort select state from URL params on page load
document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const sortEl = document.getElementById('collection-sort');
  const availEl = document.getElementById('collection-availability');
  if (sortEl && params.get('sort_by')) sortEl.value = params.get('sort_by');
  if (availEl && params.get('filter.p.availability')) availEl.value = params.get('filter.p.availability');
});

// Thumbnail gallery switcher
document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

// Scroll-hide header — desktop only (768px+)
const header = document.querySelector('.site-header');
if (header) {
  let lastScroll = 0;
  const desktopMQ = window.matchMedia('(min-width: 768px)');

  window.addEventListener('scroll', () => {
    if (!desktopMQ.matches) return;
    const current = window.scrollY;
    if (current > lastScroll && current > 80) {
      header.style.transform = 'translateY(-100%)';
      header.style.transition = 'transform 0.3s ease';
    } else {
      header.style.transform = 'translateY(0)';
    }
    lastScroll = current;
  });

  // Reset any scroll-applied transform when resizing to mobile
  desktopMQ.addEventListener('change', e => {
    if (!e.matches) header.style.transform = '';
  });
}
